export default __webpack_public_path__ + "static/media/FITUR QIANA 3.ae70b7ec.png";